import { useSyncExternalStore } from 'react';

/**
 * حالةُ نافذة المساعد — مخزنٌ صغير بلا سياق كـ`tour-store`: زرُّ «اسأل المساعد» في الترويسة وفي
 * «المزيد» وفي منصة الطفل وفي الصفحات العلنية وفي لوحة البحث كلُّها تنادي `openAssistant`،
 * و`App` وحده يرسم النافذة مرّةً. `initialQuestion` يُمرَّر من لوحة البحث حين لا تجد شاشةً بذلك الاسم.
 */
type AssistantState = { open: false } | { open: true; initialQuestion: string };

let state: AssistantState = { open: false };
const subs = new Set<() => void>();
const emit = () => { for (const s of subs) s(); };

export function openAssistant(initialQuestion = ''): void { state = { open: true, initialQuestion }; emit(); }
export function closeAssistant(): void { state = { open: false }; emit(); }

export function useAssistantState(): AssistantState {
  return useSyncExternalStore(
    (cb) => { subs.add(cb); return () => { subs.delete(cb); }; },
    () => state,
    () => state,
  );
}

/**
 * «أبلغ عن مشكلة» بالمخزن نفسِه: زرُّه في قائمة «؟» وفي «المزيد» — واللوحُ الجانبي على الجوال يحمل
 * `transform` فيصير حاويةَ كل `position: fixed` داخله، ونافذةٌ تُرسم من داخله تنزلق معه خارج الشاشة
 * حين يُغلق. فالنافذةُ تُرسم مرّةً في `App` خارج القشرات كلِّها.
 */
let report = false;
const reportSubs = new Set<() => void>();
const emitReport = () => { for (const s of reportSubs) s(); };
export function openReportProblem(): void { report = true; emitReport(); }
export function closeReportProblem(): void { report = false; emitReport(); }
export function useReportProblemOpen(): boolean {
  return useSyncExternalStore(
    (cb) => { reportSubs.add(cb); return () => { reportSubs.delete(cb); }; },
    () => report,
    () => report,
  );
}
